import { createFileRoute } from '@tanstack/react-router';

import { getDisciplineOptions } from '@/module/Discipline/model/DisciplineQuery';

export const Route = createFileRoute(
  '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout',
)({
  loader: async ({ params: { disciplineId }, context: { queryClient } }) => {
    const discipline = await queryClient.ensureQueryData(getDisciplineOptions(disciplineId));

    return {
      discipline,
      crumb: discipline.name,
    };
  },
});
